import axios from 'axios';
import { Coordinates } from '../types/models/Coordinates';

export async function getCoordinates(location: string): Promise<Coordinates> {
  const url = `/api/analyzers/location/${location}`;

  try {
    const { data } = await axios.get(url);
    return data as Coordinates;
  } catch (err) {
    throw err;
  }
}

